<template>
  <div class="content-block">
    <TaskForm
      :preselectedProjectId="preselectedProjectId"
      :parentTask="parentTask"
      @done="onDone"
    ></TaskForm>
  </div>
</template>

<script>
import TaskForm from 'CORE/components/task/form'
import get from 'lodash/get'

export default {
    name: 'TaskNewView',
    components: {
        TaskForm,
    },
    computed: {
        preselectedProjectId() {
            return get(this.$route.query, 'preselectedProjectId')
        },
        parentTask() {
            return get(this.$route.query, 'parentTask')
        },
    },
    methods: {
        onDone() {
            const backProjectId = get(this.$route.query, 'backProjectId', false)
            if (backProjectId) {
                this.$router.push({ name: 'projectsDetail', params: { id: backProjectId } })
            } else {
                this.$router.push('/tasks/list')
            }
        },
    },
}
</script>
